/* eslint-disable no-console */

import Vue from 'vue';
import Vuex from 'vuex';

import moment from 'moment';

import Randomizer from '@/tools/randomizer'

Vue.use(Vuex);
export default new Vuex.Store({
  state: () => ({
    // question lists
    drills: [],
    setting: [],
    config: {},

    // paging
    mode: 'index',
    drillId: -1,
    questionId: -1,
    endTime: null,

    // answers list
    optionOrder: [],
    response: [],
    correct: [],
    sent: [],

    modal: false,
  }),
  mutations: {
    setMode(state, pl) {
      state.mode = pl;
    },
    setQuestions(state, pl) {
      state.drills = pl.questionList;
      state.setting = pl.setting;
    },
    home(state) {
      state.optionOrder = [];
      state.response = [];
      state.correct = [];
      state.sent = [];
      state.modal = false;
      state.questionId = -1;
      state.drillId = -1;
      state.mode = 'index';
      state.endTime = false;
    },
    startQuestion(state, pl) {
      state.optionOrder = [];
      state.response = [];
      state.correct = [];
      state.sent = [];
      state.modal = false;
      state.questionId = -1;
      state.drillId = pl;
      state.mode = 'question';
      state.endTime = false;
    },
    setConfig(state, pl) {
      Vue.set(state.config, pl.key, pl.value)
    },
    changeQuestion(state, pl) {
      state.questionId = pl;
    },
    setOptionOrder(state, pl) {
      Vue.set(state.optionOrder, state.questionId, pl);
    },
    setResponse(state, pl) {
      Vue.set(state.response, state.questionId, pl.response);
      Vue.set(state.correct, state.questionId, pl.correct);
    },
    setSent(state) {
      Vue.set(state.sent, state.questionId, true);
    },
    setModal(state, pl) {
      state.modal = pl;
    },
    end(state) {
      state.endTime = moment();
      state.mode = 'end';
    }
  },
  getters: {
    drill(state) {
      return state.drills[state.drillId]
    },
    qId(state, getters) {
      return getters.list[state.questionId];
    },
    question(state, getters) {
      return getters.drill.questions[getters.qId];
    },
    optionOrder(state) {
      return state.optionOrder[state.questionId];
    },
    option(state, getters) {
      return getters.optionOrder ? getters.optionOrder.map((e) => getters.question.question.option[e]) : false;
    },
    response(state) {
      return state.response[state.questionId];
    },
    sent(state) {
      return state.sent[state.questionId];
    },
    answer(state, getters) {
      if (getters.question.question.type === 'input') {
        return getters.question.question.answer;
      }
      if (Array.isArray(getters.question.question.answer)) {
        return getters.question.question.answer.map(e => e - 1);
      }
      return getters.question.question.answer - 1;
    },
    history(state, getters) {
      const la = localStorage.getItem(
        `SukenDrill::${state.setting.id}_${getters.drill.id}::HISTORY`
      );

      if (la) {
        return JSON.parse(la);
      }
      return [];
    },
    lastCorrected(state, getters) {
      const lc = localStorage.getItem(
        `SukenDrill::${state.setting.id}_${getters.drill.id}::QUESTIONANSWER`
      );
      if (lc) {
        return JSON.parse(lc);
      }
      return [];
    },
    list(state, getters) {
      console.log('listing');
      console.log(state.config);
      const list = [];

      const isLastPassed = getters.lastCorrected.every(e => e === true);

      getters.drill.questions.forEach((e, i) => {
        if (
          state.config.expectLastCorrect &&
          !isLastPassed
        ) {
          const target = getters.history.data.find(history => {return history.id === i})

          if ((target && !target.tof)) {
            list.push(i);
            return;
          }
          console.log('not pushed' + i)
        } else {
          list.push(i);
        }
      })

      if (state.config.random) {
        return Randomizer(list);
      }
      return list;
    },

    questionHistory(state, getters) {
      const history = getters.list.map((e, now) => {
        return {
          listNo: now,
          id: e,
          res: state.response[now] ? state.response[now] : null,
          tof: state.correct[now] ? state.correct[now] : null,
        }
      })

      if (state.endTime) {
        // 直近ヒストリーの保存
        localStorage.setItem(
          `SukenDrill::${state.setting.id}_${getters.drill.id}::HISTORY`,
          JSON.stringify({ data: history, date: state.endTime }),
        );

        localStorage.setItem(
          `SukenDrill::${state.setting.id}_${getters.drill.id}::QUESTIONANSWER`,
          JSON.stringify(history.map(e => e.tof)),
        );
      }

      return { data: history, date: state.endTime };
    }
  }
});